/**
 * Rótulos e cores de status/forma de pagamento de `Billing`.
 *
 * Estavam copiados em cinco telas, já divergindo entre si ("Transferência" vs
 * "Transferência Bancária", "Maquininha" vs "Maquininha (terminal)"). Aqui é a
 * cópia canônica; as telas antigas continuam com a sua até serem migradas.
 *
 * Os valores das chaves espelham os enums do backend — mudar uma chave aqui
 * sem mudar lá faz a tela cair no fallback e exibir o enum cru.
 */

export const BILLING_STATUS_LABELS: Record<string, string> = {
    PENDING: 'Pendente',
    PAID: 'Pago',
    OVERDUE: 'Vencido',
    CANCELLED: 'Cancelado',
    REFUNDED: 'Estornado',
    PARTIALLY_REFUNDED: 'Parcialmente estornado',
    PARTIALLY_PAID: 'Parcial',
    IN_DISPUTE: 'Em disputa',
    WRITTEN_OFF: 'Baixado',
}

export const BILLING_STATUS_BADGE: Record<string, string> = {
    PENDING: 'badge-warning',
    PAID: 'badge-success text-white',
    OVERDUE: 'badge-error text-white',
    CANCELLED: 'badge-ghost',
    REFUNDED: 'badge-info text-white',
    PARTIALLY_REFUNDED: 'badge-info',
    PARTIALLY_PAID: 'badge-warning',
    IN_DISPUTE: 'badge-error text-white',
    WRITTEN_OFF: 'badge-ghost',
}

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
    PIX: 'PIX',
    BOLETO: 'Boleto',
    CREDIT_CARD: 'Cartão de Crédito',
    DEBIT_CARD: 'Cartão de Débito',
    CASH: 'Dinheiro',
    BANK_TRANSFER: 'Transferência Bancária',
    CHECK: 'Cheque',
    TERMINAL: 'Maquininha',
    OTHER: 'Outro',
}

/** Ordem de exibição em selects: os métodos mais usados no balcão primeiro. */
export const PAYMENT_METHOD_ORDER = [
    'CASH',
    'PIX',
    'CREDIT_CARD',
    'DEBIT_CARD',
    'TERMINAL',
    'BOLETO',
    'BANK_TRANSFER',
    'CHECK',
    'OTHER',
]
